import script from "./ClassicContentModule.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicContentModule.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__